module.exports = "<div class=\"app-wrap\">\n   <h2>hello world</h2>\n</div>"